import { render, staticRenderFns } from "./HabitFailedModal.vue?vue&type=template&id=6fdaf822"
import script from "./HabitFailedModal.vue?vue&type=script&lang=js"
export * from "./HabitFailedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports